import { Alert } from "@mui/material";

export default function Vimeo({id}){

    const src = `https://player.vimeo.com/video/${id}`;

    const idIsValid = !isNaN(parseInt(id)) && (id || '').toString().length > 8;

    return idIsValid ?
        <iframe
            src={src}
            frameBorder="0" 
            allow="autoplay;picture-in-picture" 
            allowFullScreen 
            title="Lecteur Vimeo"
            height={300}
        >
        </iframe>
        :
        <Alert severity="error">Identifiant Vimeo incorrect.</Alert>

}